import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
    successInRequest,
    failedRequest,
} from './actions';

export function* requestGpp({ payload }) {
    try {
        const { params } = payload;
        //const response = yield call(api.get, 'usuariomaster', {
        const response = yield call(api.get, 'usuariomaster/usuariolistagpp', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });
        const { items, page, pageSize, totalCount, totalPages } = response.data;

        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}


export function* applyedFilters({ payload }) {
    try {
        const { params } = payload;

        //const response = yield call(api.get, 'usuariomaster', {
        const response = yield call(api.get, 'usuariomaster/usuariolistagpp', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        const { items, page, pageSize, totalCount, totalPages } = response.data;

        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export default all([
    takeLatest('@postoplanejamentogpp/GPP_IN_REQUEST', requestGpp),
    takeLatest('@postoplanejamentogpp/SUCCESS_REMOVE', requestGpp),
    takeLatest('@postoplanejamentogpp/RECORD_FILTERING', applyedFilters),
]);
